module.exports = __webpack_public_path__ + "img/59.4.NH3-N.1aa15d17.png";